var _effectorFileName = "/src/shared/components/animation/orbiting-circles/orbiting-circles.tsx";
import { cn } from '@/shared/lib/cn';
interface OrbitingCirclesProps {
  className?: string;
  children?: React.ReactNode;
  reverse?: boolean;
  duration?: number;
  delay?: number;
  radius?: number;
  path?: boolean;
}
export const OrbitingCircles = (props: OrbitingCirclesProps) => {
  const {
    className,
    children,
    reverse,
    duration = 20,
    delay = 10,
    radius = 50,
    path = true
  } = props;
  return <>
      {path && <svg xmlns="http://www.w3.org/2000/svg" version="1.1" className="pointer-events-none absolute inset-0 h-full w-full">
          <circle className="stroke-black/10 stroke-1 dark:stroke-white/10" cx="50%" cy="50%" r={radius} fill="none" strokeDasharray={'4 4'} />
        </svg>}

      <div style={{
      '--duration': duration,
      '--radius': radius,
      '--delay': -delay
    } as React.CSSProperties} className={cn('absolute flex h-full w-full transform-gpu animate-orbit items-center justify-center rounded-full border [animation-delay:calc(var(--delay)*1000ms)]', {
      '[animation-direction:reverse]': reverse
    }, className)}>
        {children}
      </div>
    </>;
};